import { toggleQuestionBookmark, toggleQuestionLike } from '../../services/questionBankQuestionService';
import { toggleNoteBookmark, toggleNoteLike } from '../../services/notesFeedbackService';
import { toggleLectureBookmark, toggleLectureLike } from '../../services/lecturesService';
import { toggleBlogBookmark, toggleBlogLike } from '../../services/blogService';
import { ensureActionSuccess } from '../../services/searchService';

export async function searchSocialAction({ categoryId, id, action }) {
  const operations = {
    2: { like: toggleQuestionLike, bookmark: toggleQuestionBookmark, field: 'question_id' },
    3: { like: toggleLectureLike, bookmark: toggleLectureBookmark, field: 'lectures_id' },
    4: { like: toggleNoteLike, bookmark: toggleNoteBookmark, field: 'notes_id' },
    8: { like: toggleBlogLike, bookmark: toggleBlogBookmark, field: 'blog_id' },
  };
  const operation = operations[categoryId];
  if (!id || !operation?.[action]) throw new Error('This action is unavailable.');
  return ensureActionSuccess(await operation[action]({ [operation.field]: id }));
}
